import ACTIONS from "../actions/types";
const setDefaultLang = (lang) => {
  localStorage.setItem("selected_language", lang);
  return lang;
};
const initialState = {
  language: localStorage.getItem("selected_language") ? localStorage.getItem("selected_language") : setDefaultLang("da"),
  languages: ["da", "en"],
};

const i18nReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_LANGUAGE:
      localStorage.setItem("selected_language", action.payload);
      return Object.assign({}, state, {
        language: action.payload,
      });
    default:
      return state;
  }
};

export default i18nReducer;
